export default __webpack_public_path__ + "static/media/congratulation_coin.9541694c.png";